var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[(_vm.type_label === 'Strona')?_c('router-link',{staticClass:"is-tab nav-item newmenuitem",attrs:{"to":_vm.cutName(_vm.url),"data-url":_vm.url}},[_vm._v(_vm._s(_vm.title))]):_c('a',{staticClass:"is-tab nav-item",attrs:{"href":_vm.url,"rel":"noopener"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }